import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import Button from '@material-ui/core/Button'
import * as Notification from './notification'

import './styles.css'

const MAX_CANTIDAD_SUBIDA_ARCHIVOS = 4

class DragAndDrop extends React.Component {
    constructor(props){
        super(props)

        this.state ={ 
            imgSrc: ''}
        }
    

    onDrop = (acceptedFiles, rejectedFiles) => {
        
        if((rejectedFiles.length + acceptedFiles.length) > MAX_CANTIDAD_SUBIDA_ARCHIVOS){
            Notification.showInfo(`No puede subir más de ${MAX_CANTIDAD_SUBIDA_ARCHIVOS} fotos por vez.`)
            return
        }

        const MAX_FILE_SIZE = 200 * 1024; 
        const archivosInvalidos = acceptedFiles.filter(file => file.size > MAX_FILE_SIZE);

        if (archivosInvalidos.length > 0) {
            const nombres = archivosInvalidos.map(f => f.name).join(', ');
            Notification.showInfo(`Los archivos (${nombres}) superan el tamaño máximo permitido (200 KB).`);
            return;
        }

        this.props.handleOnDrop(acceptedFiles, rejectedFiles)
    }

    render() {

        const dropzoneRef = React.createRef();

        return (
            <div style={this.props.style} className='dragAndDrop'>
                <Dropzone ref={dropzoneRef} 
                    className='dropzone'
                    accept={this.props.accept}
                    onDrop={this.onDrop}
                    activeClassName='dragAccepted'
                    rejectClassName='dragRejected'
                    disableClick={this.props.showButton}
                    multiple= {this.props.multiple}    
                >
                    <div className='container'>                       
                        {this.props.message && <div className='message'>{this.props.message}</div>}
                        {this.props.showButton && <Button variant="contained" className="btnPrincipal btnDragDrop" onClick={() => { dropzoneRef.current.open() }}>HAZ CLICK AQUÍ</Button>}
                        {this.props.messageBottom && <div className='messageBottom'>{this.props.messageBottom}</div>}
                    </div>
                </Dropzone>
            </div>
        )
    }
}

DragAndDrop.propTypes = {
    accept: PropTypes.string.isRequired,
    handleOnDrop: PropTypes.func.isRequired,
    message: PropTypes.string,
    messageBottom: PropTypes.string,
    showButton: PropTypes.bool,
    multiple: PropTypes.bool
}

DragAndDrop.defaultProps = {
    showButton: true,
    multiple: false
}

export default DragAndDrop